import { render, staticRenderFns } from "./IndexNoteComponent.vue?vue&type=template&id=2471ff41&"
import script from "./IndexNoteComponent.vue?vue&type=script&lang=js&"
export * from "./IndexNoteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports